<template>
    <label class="d-block m-0 py-3 border-bottom">
        {{ $t('taxi.pages.summary.payment_ecard') }}
    </label>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters({
                paymentMethod: 'businessTaxi/getPaymentMethod',
            }),
        },

        methods: {

        },
    };
</script>
